import { Type } from 'class-transformer'

import BaseValue from '../PropertyConditionValues/BaseValue'
import { SetPropertyActionValue } from '../PropertyConditionValues/BaseValue'
import CalculateValue from '../PropertyConditionValues/CalculateValue'
import ConstantValue from '../PropertyConditionValues/ConstantValue'
import NowValue from '../PropertyConditionValues/NowValue'
import PropertyValue from '../PropertyConditionValues/PropertyValue'
import { ConditionOptions, ConditionType } from '../types'
import BaseCondition from './BaseCondition'

export enum PropertyConditionAction {
  More = 'More',
  Less = 'Less',
  MoreOrEquals = 'MoreOrEquals',
  LessOrEquals = 'LessOrEquals',
  Equals = 'Equals',
  Contains = 'Contains',
  StartsWith = 'StartsWith',
  EndsWith = 'EndsWith',
  BetweenProperty = 'BetweenProperty',
  FlagProp = 'FlagProp',
  True = 'True',
  False = 'False',
  IsSet = 'IsSetProperty',
  IsNotSet = 'IsNotSetProperty',
}

export default class PropertyCondition extends BaseCondition {
  declare type: ConditionType.Property
  action!: PropertyConditionAction
  options!: Array<ConditionOptions>

  @Type(() => BaseValue, {
    keepDiscriminatorProperty: true,
    discriminator: {
      property: 'type',
      subTypes: [
        { name: SetPropertyActionValue.Property, value: PropertyValue },
        { name: SetPropertyActionValue.Now, value: NowValue },
        { name: SetPropertyActionValue.Constant, value: ConstantValue },
        { name: SetPropertyActionValue.Calculate, value: CalculateValue },
      ]
    }
  })
  left!: BaseValue

  @Type(() => BaseValue, {
    keepDiscriminatorProperty: true,
    discriminator: {
      property: 'type',
      subTypes: [
        { name: SetPropertyActionValue.Property, value: PropertyValue },
        { name: SetPropertyActionValue.Now, value: NowValue },
        { name: SetPropertyActionValue.Constant, value: ConstantValue },
        { name: SetPropertyActionValue.Calculate, value: CalculateValue },
      ]
    }
  })
  right!: BaseValue
}
